import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import styled from "styled-components";

const HEADER_HEIGHT = 52;

export const Container = styled.div(({}) => ({
    width: "100vw",
    height: "100vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
        display: "none !important",
        width: 0,
        height: 0,
    },
    scrollbarWidth: "none",
    "-ms-overflow-style": "none",
}));

export const ImageContainer = styled.div(({ theme }) => ({
    width: "100%",
    padding: `${theme.spacing.medium} 0 ${theme.spacing.xLarge}`,
    aspectRatio: "1.86",
}));

export const ContentContainer = styled.div(({ theme }) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: `0px ${theme.spacing.medium} ${theme.spacing.medium}`,
}));

export const AmountContainer = styled.div(({ theme }) => ({
    zIndex: "0",
    marginTop: theme.spacing.large,
}));

export const MessageContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xLarge,
    marginBottom: theme.spacing.xxLarge,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    position: "fixed",
    width: "100%",
    background: theme.colors[theme.colorMode].background_Primary,
    left: 0,
    bottom: 0,
    padding: theme.spacing.medium,
    boxShadow: "0px -4px 8px 0px rgba(27, 30, 36, 0.08)",
    paddingBottom: `calc(${theme.spacing.medium} + var(--sab, 0px))`,
}));

export const AmountBoxes = styled.div(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing.large,
}));

export const HeaderContainer = styled.div(({ theme }) => ({
    display: "flex",
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const HowItWorksImageContainer = styled.div(({ theme }) => ({
    paddingBottom: `calc(${theme.spacing.xxLarge} * 3 + var(--sab, 0px))`,
}));

export const FaqHeaderContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    marginRight: theme.spacing.medium,
    "@supports (margin-top: var(--sat))": {
        paddingTop: "var(--sat)",
        marginTop: 0,
        height: `calc(${HEADER_HEIGHT}px + var(--sat))`,
        minHeight: `calc(${HEADER_HEIGHT}px + var(--sat))`,
    },
}));

export const AmountSelectionWidget = styled.div(({ theme }) => ({
    borderTop: `1px dashed ${theme.colors[theme.colorMode].divider}`,
    borderBottom: `1px dashed ${theme.colors[theme.colorMode].divider}`,
    paddingTop: `calc(${theme.spacing.medium} + ${theme.spacing.xxSmall})`,
    paddingBottom: theme.spacing.xLarge,
}));

export const FaqButtonStyledButton = styled(TextButton)(({ theme }) => ({
    padding: `${theme.spacing.xSmall} 0px`,
}));

export const MessageTitleStyledText = styled(Text)(({ theme }) => ({
    marginBottom: `calc(${theme.spacing.small} + ${theme.spacing.xxxSmall})`,
}));

export const DiscountSubtitleStyledText = styled(Text)(({ theme }) => ({
    marginTop: theme.spacing.xxSmall,
}));
